import { BackgroundAuth, CardAuth, LoginAuth, TitleAuth } from './layoutAuthStyle'
import { logo } from '../../constants/images'
import { useTranslation } from 'react-i18next';
interface propsTypes {
    children: any
}
export default function LayoutAuth(props: propsTypes) {
    const { children } = props
    const { t } = useTranslation();

    return (
        <BackgroundAuth>
            <CardAuth>
                <LoginAuth src={logo.logoLogin} alt='logo-login' />
                <TitleAuth>{t('LOGIN.TITLE')} <br />(Lampang Center)</TitleAuth>
                {children}
            </CardAuth>
        </BackgroundAuth>
    )
}
